module.exports = __webpack_public_path__ + "static/media/vg.36d75200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/vg.png
// module id = 2017
// module chunks = 0